import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        const userSessionKey = 'wa360_session';
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const getTopLevelDomain = (domain) => {
            // this should return only the
            // extension and the top level of the domain
            // ex: futurewalottery.com
            // from stg01.mylottery360.futurewalottery.com
            return domain.split('.').slice(-2).join('.');
        };

        const setCookieValueByName = (cookieName, cookieValue) => {
            if (typeof document === 'undefined') {
                return;
            }

            document.cookie = `${cookieName}=${cookieValue}; Path=/; Domain=${getTopLevelDomain(document.location.hostname)}`;
            return cookieValue;
        };

        let result = await apiClient(config).apiMethod({
            method: 'CTLVerify',
            args: {
                firstname: payload.firstname,
                lastname: payload.lastname,
                birthdate: payload.birthdate,
                address: {
                    state: payload.address.state,
                    address1: payload.address.address1,
                    address2: payload.address.address2,
                    city: payload.address.city,
                    zip: payload.address.zip,
                },
                phone: payload.phone,
                email: payload.email,
                ssn: payload.ssn,
                registrar_id: payload.registrar_id,
            },
        });

        // {"code":"_VALIDATION","message":"Input validation error.","data":{"ticket_number":["The ticket number field is required."]},"extended":""}
        if (result.code) {
            return {
                success: false,
                errors: result.code,
            };
        } else if (result) {
            return {
                entry: result,
                success: true,
                errors: 'success',
            };
        } else {
            return {
                success: false,
                errors: ' _UNKNOWN',
            };
        }
    };
};
